import styled, { css } from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

interface MenuItemProps {
  $selected?: boolean;
}

export const MenuWrapper = styled.div`
  position: relative;
  width: 100%;
  margin-top: 12px;

  ${({ theme }) => theme.media.mobile} {
    width: calc(100% + 32px);
    left: -16px;
  }

  ${({ theme }) => theme.media.tablet} {
    width: calc(100% + 64px);
    left: -32px;
  }
`;

export const MenuList = styled.div`
  display: flex;

  position: relative;
  width: 100%;
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const MenuItem = styled.a<MenuItemProps>`
  display: block;
  padding: 8px 16px;
  color: ${({ theme }) => theme.colors.gray700};
  margin-right: 12px;
  border-radius: 25px;
  border: 1px solid ${({ theme }) => theme.colors.gray400};
  white-space: nowrap;
  user-select: none;
  ${getFontStyle('midium150_B3')}

  ${({ $selected }) =>
    $selected &&
    css`
      background-color: ${({ theme }) => theme.colors.magenta100};
      border-color: ${({ theme }) => theme.colors.magenta700};
      color: ${({ theme }) => theme.colors.magenta700};
    `}

  &:last-of-type {
    margin-right: 0;
  }

  ${({ theme }) => theme.media.mobile} {
    &:first-of-type {
      margin-left: 16px;
    }

    &:last-of-type {
      margin-right: 16px;
    }
  }

  ${({ theme }) => theme.media.tablet} {
    &:first-of-type {
      margin-left: 32px;
    }

    &:last-of-type {
      margin-right: 32px;
    }
  }
`;

export const IntersectionHolder = styled.div`
  flex: 0 0 1px;
`;

const Arrow = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
  z-index: 10;
`;

export const ArrowPrev = styled(Arrow)`
  left: 0;
`;

export const ArrowNext = styled(Arrow)`
  right: 0;
`;
